// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/onsenui/css/onsenui.css
// module id = 506
// module chunks = 1